import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BlacklistPropertiesOverlayComponent } from './blacklist-properties-overlay.component';

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		InputComponentModule,
		LabelComponentModule,
		TextComponentModule,
		ToggleSwitchComponent,
	],
	declarations: [BlacklistPropertiesOverlayComponent],
	exports: [BlacklistPropertiesOverlayComponent]
})
export class BlacklistPropertiesOverlayModule {

}
